<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :rules="rules"
    :clearable="!withoutClearable"
    :label="label"
    return-object
    hide-details
    hide-selected
    browser-autocomplete="nope"
    no-filter
    no-data-text="Данные не выбраны"
    :class="{ 'red lighten-4': selected && selected.isRemoved }"
    outline
    :menu-props="menuPropsClose"
    height="44"
    :error="error"
    :disabled="disabled"
    prepend-inner-icon="folder_open"
    @change="handleItemChange"
    @click:clear="clearSelected"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <AddReferenceBtn @click="createNew" />
    </template>
  </v-autocomplete>
</template>
<script>
import AddReferenceBtn from "../AddReferenceBtn.vue";
import CloseDropdownList from "../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import * as newShippingApi from "../../backend/newShippingApi.js";
import _ from "lodash";

export default {
  components: { AddReferenceBtn },
  mixins: [CloseDropdownList],
  props: [
    "value",
    "label",
    "rules",
    "error",
    "scrollValue",
    "disabled",
    "withoutClearable",
  ],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      resource: "employees",
      componentName: "Employee",
      loading: false,
    };
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (this.selected && this.value.id === this.selected.value) {
          return;
        }
        const selectedItem = this.items.find(i => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.selected && this.selected.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(() => {
        if (!this.search) {
          this.selected = null;
          this.items = [];
          this.loading = false;
          return;
        }
        this.searchManager();
        this.loading = false;
      }, 500);
    },
    scrollValue() {
      if (!this.scrollValue) {
        return;
      }
      closeActivList(this.$children[0]);

      function closeActivList(value) {
        if (value.isActive) {
          value.isActive = false;
        }
        if (value.$children) {
          value.$children.forEach(v => closeActivList(v));
        }
      }
    },
  },
  created() {
    if (this.value) {
      this.setSelectedElement(this.value);
    }
    NestedEditorsEventBus.$on("create-" + this._uid, createdId => {
      this.getManagerReference(createdId);
      this.handleItemChange();
    });
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      newVal => {
        if (newVal) {
          this.fetchAll();
        } else {
          this.clear();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? {
            id: this.selected.value,
            title: this.selected.text,
            inputLanguage: this.selected.inputLanguage,
          }
          : null,
      );
    },
    async fetchAll() {
      this.items = await newShippingApi.getAllManagers(this.resource);
      this.loading = false;
    },
    clear() {
      this.items = [];
      if (this.selected) {
        this.items.push(this.selected);
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
      });
    },
    setSelectedElement(value) {
      const transformValueKeys = _.transform(value, function(result, val, key) {
        result[key.toLowerCase()] = val;
      });
      const newItem = {
        text: transformValueKeys.title,
        value: transformValueKeys.id,
        inputLanguage: transformValueKeys.inputLanguage,
        isRemoved: transformValueKeys.isRemoved,
      };
      this.items.push(newItem);
      this.selected = newItem;
    },
    async getManagerReference(id) {
      const response = await newShippingApi.getManagerReference(
        this.resource,
        id,
      );
      this.setSelectedElement(response);
    },
    async searchManager() {
      this.items = await newShippingApi.searchManager(
        this.resource,
        this.search,
      );
    },
    clearSelected() {
      this.$emit("input", null);
    },
  },
};
</script>
